import VIEWPORTS from '../plugins/viewports'
import PARTSLOADER from '../plugins/partsloader'

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp'

// カレンダーカスタマイズ
// import FULLCALENDAR from '../plugins/fullcalendar'

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'contentFooter': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'footer': new $.Deferred, // PARTSLOADERの`name`と合わせる
    'mapScript': new $.Deferred, // googlemapAPIのURLパラメータでresolveします
  }

  VIEWPORTS() // Viewportの置き換え

  LAZYDISP('[data-lazydisp]') // lazydisp実行 使い方は`/less/component/lazydisp.less`を参照
  
  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html',
      target: 'footer #footerNav',
      method:'replaceWith'
    },
    {
      name: 'contentFooter',
      loadhtml: '/asset/html/contentFooter.html?ts=20200403',
      target: 'footer,#footer.ui-footer',
      method:'before',
      callback(r,_){
        $('.homeContentslist').insertBefore('#footer');
        $('.p-footer__nav').currentMenu({mode:1,default:999});
      }
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html',
      target: 'header',
      method:'replaceWith',
      callback(r,_){
        $('header .p-gnav').currentMenu({mode:1,default:999});
      }
    }
  ])

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // カレントメニュー
    $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    // ページングテキスト
    $.pagingText({
      prev:'PREV',
      next:'NEXT',
      list:'LIST'
    })
    // ページトップリンクをスクロール量で表示するサンプル
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
  })

  window.load['contentFooter'].done(() => {

    // pagetopをstickyするため
    if( $('#allbox').length ){
      const $inner = $('<div class="allbox__inner" />')
      const $pagetop = $(`
        <div class="p-gotop__wrap hidden"><a href="#pagetop" class="p-gotop">GO TOP</a></div>
        <!-- /.p-gotop__wrap -->
      `)
      $('#allbox').wrapInner($inner)

      // innerからツールバーとフッターを外に出す
      $('#allbox').find('.toolbar').prependTo( '#allbox' )
      $('#allbox').find('footer').appendTo( '#allbox' )

      // pagetopのDOM挿入
      $('#allbox footer').before( $pagetop )
    }

  })

}